// Angular
import { Component, OnInit } from '@angular/core';
// Models
// import { Post } from './../../models/post';
// External
import { AngularFireDatabase } from 'angularfire2/database';
import * as moment from 'moment';
import * as lodash from 'lodash';
import { ApiService } from '../../services/api';

import { OAuthService } from '../../services/o-auth';


import { ActivatedRoute } from '@angular/router';

@Component({
    templateUrl: './league-detail.component.html'
})
export class LeagueDetailComponent implements OnInit {
    public league: any
    public leagueId :String
    constructor(private route: ActivatedRoute, private fireDatabase: AngularFireDatabase, 
        private oAuthService: OAuthService, private apiService: ApiService, ) {
            this.leagueId = this.route.snapshot.paramMap.get('id');


    }
    ngOnInit() {

        this.apiService.object("leagues/"+this.leagueId).then((res) => {
            this.league =res
            this.league.tournamentNames=[]
            for (let i = 0; i < Object.keys(this.league.tournaments).length; i++) {
                const t_id = Object.keys(this.league.tournaments)[i];
                this.league.tournamentNames.push(this.league.tournaments[t_id])
                
            }
           console.log(this.league)
        })
    }



}

